import React from "react";

const STYLES = {
  declassified: "bg-[#ffd60a]/10 text-[#ffd60a] border-[#ffd60a]/40",
  mainstream: "bg-blue-500/10 text-blue-400 border-blue-500/40",
  independent: "bg-purple-500/10 text-purple-400 border-purple-500/40",
  unverified: "bg-[#ff3b30]/10 text-[#ff3b30] border-[#ff3b30]/40",
  ai_compiled: "bg-[#00ff88]/10 text-[#00ff88] border-[#00ff88]/40",
};

const LABELS = {
  declassified: "DECLASSIFIED",
  mainstream: "MAINSTREAM",
  independent: "INDEPENDENT",
  unverified: "UNVERIFIED",
  ai_compiled: "AI-COMPILED",
};

export const CredibilityBadge = ({ level = "unverified", className = "" }) => {
  const style = STYLES[level] || STYLES.unverified;
  return (
    <span
      data-testid={`credibility-badge-${level}`}
      className={`font-mono text-[10px] tracking-[0.18em] px-2 py-1 border ${style} ${className}`}
    >
      {LABELS[level] || level.toUpperCase()}
    </span>
  );
};

export default CredibilityBadge;
